import { CONFIGS, useConfigQuery } from '@buildwise/libs/configurations';
import HandleOperation from 'components/utils/HandleOperation';
import useUserData from 'hooks/useUserData';
import NoProjectRetrospectives from './NoProjectRetrospectives';
import RetrospectiveSkeleton from './RetrospectiveSkeleton';
import { ProjectRetroProvider } from '../../context';
import { ArticleFieldsType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import { useArticleInputFields } from '@buildwise/libs/posts';
import Retrospectives from './Retrospectives';
import { Grid } from '@mui/material';

function ProjectRetrospectives() {
  const { companyId } = useUserData();
  const { activeUniqueEntries, isLoading, isError } = useConfigQuery({
    companyId,
    configName: CONFIGS.RETROSPECTIVE_PHASES.configName,
  });
  const { articleFields } = useArticleInputFields({
    articleFieldsType: ArticleFieldsType.LESSON,
    isEditing: false,
  });

  return (
    <HandleOperation
      isLoading={isLoading}
      isError={isError}
      data={activeUniqueEntries}
      noDataComponent={<NoProjectRetrospectives />}
      skelton={<RetrospectiveSkeleton />}
      skeltonCount={1}
    >
      <ProjectRetroProvider initialState={{ articleFields: articleFields }}>
        <Retrospectives />
      </ProjectRetroProvider>
    </HandleOperation>
  );
}

export default ProjectRetrospectives;
